// @ts-nocheck
import * as React from "react";

const ThreadRollingDieChanges: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="164.000000pt"
            height="186.000000pt"
            viewBox="0 0 164.000000 186.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,186.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M914 1428 c-173 -179 -237 -406 -204 -723 5 -49 7 -91 5 -93 -2 -2 -20 8 -40 24 -78 59 -125 165 -125 281 0 79 -14 82 -62 11 -83 -123 -110 -210 -110 -353 0 -118 16 -185 44 -185 22 0 22 -6 2 77 -27 115 -5 271 52 371 14 23 28 42 32 42 4 0 8 -19 10 -43 4 -54 39 -132 83 -182 40 -45 114 -95 142 -95 18 0 19 5 13 48 -4 26 -9 119 -13 207 -5 143 -3 169 16 245 27 108 78 215 138 292 l48 60 11 -94 c21 -164 61 -273 159 -427 31 -49 65 -113 77 -142 28 -72 36 -234 15 -302 -13 -41 -13 -49 -2 -54 23 -8 32 4 45 67 30 142 -3 299 -95 440 -112 173 -165 329 -165 493 0 64 -3 87 -13 87 -7 0 -36 -24 -63 -52z" />
                <path d="M516 1341 c-4 -6 3 -38 15 -71 19 -52 21 -73 16 -146 -5 -76 -4 -85 10 -82 9 2 21 19 26 38 11 43 3 170 -13 200 -15 29 -11 31 32 19 34 -9 89 -59 101 -91 4 -11 7 -11 18 0 23 21 -17 82 -71 109 -55 27 -125 40 -134 24z" />
                <path d="M1259 1208 c-1 -7 -1 -21 0 -30 4 -35 -21 -144 -40 -177 -14 -24 -17 -37 -9 -45 19 -19 49 26 69 104 l19 75 35 -76 c67 -148 91 -250 90 -399 0 -92 -15 -193 -38 -252 -5 -14 -2 -18 14 -18 34 0 53 82 58 250 4 131 2 154 -21 245 -27 103 -89 246 -132 303 -26 33 -43 41 -45 20z" />
                <path d="M258 1084 c-4 -3 -2 -20 3 -37 23 -81 7 -188 -57 -367 -22 -64 -26 -86 -22 -155 6 -90 22 -135 50 -135 22 0 22 -3 3 50 -23 66 -19 163 11 245 49 133 65 207 62 278 -2 37 0 67 3 67 6 0 33 -30 81 -88 8 -10 13 -11 22 -2 16 16 -22 78 -73 118 -40 30 -70 40 -83 26z" />
            </g>
        </svg>
    );
};

export default React.memo(ThreadRollingDieChanges);
